module.exports = {"cn":{"back":"返回上一页","first":"首页","prev":"上一页","next":"下一页","gonga":"共计","tiao":"条","gongb":"共","ye":"页"},"en":{"back":"Back","first":"First","prev":"Prev","next":"Next","gonga":"Total","tiao":"Strip","gongb":"Total","ye":"Page"}}


//////////////////
// WEBPACK FOOTER
// ./src/js/newspage.json
// module id = kdY6
// module chunks = 1